/* JUSTYOL — Parfumora pack builder.
   Enforces the per-group pick count, records the choices as line-item
   properties on the fixed-price pack, adds it to the cart, then hands off to
   the existing COD express popup ([data-jy-cta="express"]). */
(function () {
  'use strict';
  var root = document.querySelector('[data-jy-pp]');
  if (!root || root.__jyPP) return;
  root.__jyPP = true;

  var isAr = root.getAttribute('data-ar') === '1';
  var vid = root.getAttribute('data-vid');
  var addBtn = root.querySelector('[data-jy-pp-add]');
  var addLbl = root.querySelector('[data-jy-pp-addlbl]');
  var progress = root.querySelector('[data-jy-pp-progress]');
  var errEl = root.querySelector('[data-jy-pp-err]');
  var groups = [].slice.call(root.querySelectorAll('[data-jy-pp-group]'));

  function t(fr, ar) { return isAr ? ar : fr; }
  function showErr(msg) {
    if (!errEl) return;
    errEl.textContent = msg;
    errEl.hidden = false;
    setTimeout(function () { errEl.hidden = true; }, 3500);
  }

  /* ---------- gallery thumbs ---------- */
  var stageImg = root.querySelector('.jypp__img');
  root.querySelectorAll('[data-jy-pp-thumb]').forEach(function (th) {
    th.addEventListener('click', function () {
      var img = th.querySelector('img');
      if (img && stageImg) {
        stageImg.src = img.src.replace(/width=140/, 'width=900');
        stageImg.srcset = '';
      }
      root.querySelectorAll('[data-jy-pp-thumb]').forEach(function (o) { o.classList.remove('is-on'); });
      th.classList.add('is-on');
    });
  });

  /* ---------- plain (unconfigured) pack ---------- */
  if (addBtn && addBtn.getAttribute('data-plain') === '1') {
    addBtn.addEventListener('click', function () { addToCart({}); });
    return;
  }
  if (!groups.length) return;

  /* ---------- group selection state ---------- */
  function count(g) { return parseInt(g.getAttribute('data-count'), 10) || 0; }
  function picked(g) { return [].slice.call(g.querySelectorAll('[data-jy-pp-pick].is-picked')); }

  groups.forEach(function (g) {
    var max = count(g);
    g.addEventListener('click', function (e) {
      var card = e.target.closest('[data-jy-pp-pick]');
      if (!card) return;
      var chosen = picked(g);
      if (card.classList.contains('is-picked')) {
        card.classList.remove('is-picked');
      } else if (chosen.length >= max) {
        // at the limit — nudge instead of silently ignoring
        card.classList.add('jypp__card--shake');
        setTimeout(function () { card.classList.remove('jypp__card--shake'); }, 400);
        showErr(t('Vous avez déjà choisi ' + max + ' articles pour cette étape.',
          'اخترت بالفعل ' + max + ' في هذه الخطوة.'));
        return;
      } else {
        card.classList.add('is-picked');
      }
      refresh();
    });
  });

  function groupDone(g) { return picked(g).length === count(g); }
  function allDone() { return groups.every(groupDone); }

  function refresh() {
    groups.forEach(function (g) {
      var c = g.querySelector('[data-jy-pp-counter]');
      var n = picked(g).length;
      if (c) c.textContent = n + '/' + count(g);
      g.classList.toggle('is-done', groupDone(g));
    });
    var ready = allDone();
    if (addBtn) addBtn.disabled = !ready;
    if (progress) {
      var doneCount = groups.filter(groupDone).length;
      progress.textContent = ready
        ? t('Sélection complète ✓', 'اكتمل الاختيار ✓')
        : t('Étape ' + Math.min(doneCount + 1, groups.length) + ' sur ' + groups.length,
            'الخطوة ' + Math.min(doneCount + 1, groups.length) + ' من ' + groups.length);
    }
    if (addLbl) {
      addLbl.textContent = ready ? t('Ajouter au panier', 'أضف إلى السلة')
                                 : t('Choisissez vos parfums', 'اختر عطورك');
    }
  }

  /* ---------- add to cart + hand off to COD express ---------- */
  function addToCart(properties) {
    if (addBtn) { addBtn.disabled = true; addBtn.classList.add('is-loading'); }
    var routes = (window.FoxTheme && FoxTheme.routes) || {};
    var addUrl = routes.cart_add_url || '/cart/add';
    fetch(addUrl + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: vid, quantity: 1, properties: properties }),
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) {
          showErr((res.j && res.j.description) || t('Impossible d’ajouter au panier.', 'تعذّر الإضافة إلى السلة.'));
          if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
          return;
        }
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        // open the COD express popup (it reads the whole cart, pack included)
        var trg = document.createElement('button');
        trg.setAttribute('data-jy-cta', 'express');
        trg.style.display = 'none';
        document.body.appendChild(trg);
        trg.click();
        setTimeout(function () { trg.remove(); }, 0);
        if (addBtn) addBtn.classList.remove('is-loading');
      })
      .catch(function () {
        showErr(t('Erreur réseau, réessayez.', 'خطأ في الشبكة، حاول مرة أخرى.'));
        if (addBtn) { addBtn.disabled = false; addBtn.classList.remove('is-loading'); }
      });
  }

  if (addBtn) {
    addBtn.addEventListener('click', function () {
      if (!allDone()) return;
      var props = {};
      groups.forEach(function (g) {
        var label = g.getAttribute('data-label') || 'Sélection';
        var names = picked(g).map(function (c) { return c.getAttribute('data-name'); });
        props[label] = names.join(', ');
      });
      addToCart(props);
    });
  }

  refresh();
})();
